export default defineNuxtRouteMiddleware((to, _) => {
  const { loggedIn } = useUserSession();
  const permissions = usePermissions(to.path);

  // Handle logged-in users
  if (loggedIn.value) {
    // Redirect to home if trying to access login routes
    if (to.path === "/login") {
      return navigateTo({
        path: "/",
        query: {
          toastMessage: "You are already logged in, redirecting to homepage...",
          toastType: "success",
        },
      });
    }

    // Redirect to previous page if trying to access without permissions
    if (!permissions.value) {
      return showError({
        statusCode: 403,
        message: "You do not have permission to access this page.",
      });
    }

    // Redirect to previous page if trying to access without permissions
    if (permissions.value.includes("view") === false) {
      return showError({
        statusCode: 403,
        message: "You do not have permission to access this page.",
      });
    }
  }

  // Handle non-logged-in users
  if (!loggedIn.value) {
    // Stop redirecting if trying to access login routes
    if (to.path === "/login") {
      return;
    }

    // Redirect to login if trying to access protected routes
    return navigateTo({
      path: "/login",
      query: {
        redirect: to.fullPath,
        toastMessage: "You need to be logged in to access this page!",
        toastType: "error",
      },
    });
  }
});
